import React from 'react';
import { RecipientType } from '../types';

interface RecipientSelectorProps {
  selectedRecipient: RecipientType | null;
  onRecipientChange: (recipient: RecipientType) => void;
  className?: string;
}

export const RecipientSelector: React.FC<RecipientSelectorProps> = ({
  selectedRecipient,
  onRecipientChange,
  className = ''
}) => {
  return (
    <div className={`chat-widget-recipient-selector ${className}`}>
      <label>Кому отправить:</label>
      
      <div className="recipient-options">
        <label className="recipient-option">
          <input
            type="radio"
            name="recipient"
            value="manager"
            checked={selectedRecipient === 'manager'}
            onChange={() => onRecipientChange('manager')}
          />
          <span>Менеджеру</span>
        </label>
        
        <label className="recipient-option">
          <input
            type="radio"
            name="recipient"
            value="technologist"
            checked={selectedRecipient === 'technologist'}
            onChange={() => onRecipientChange('technologist')}
          />
          <span>Технологу</span>
        </label>
      </div>
    </div>
  );
};
